/**
 * v-asyncClick
 * @desc 防止重复请求
 * @example
 * ```vue
 * <div v-asyncClick/>
 * ```
 */
import { DirectiveBinding } from 'vue/types/options.d';
let forbidClick: any = null;
export default {
  bind(el: HTMLElement, binding: DirectiveBinding): void {
    const btDom = el as HTMLButtonElement;
    forbidClick = () => {
      if (!btDom.disabled) {
        btDom.disabled = true;
        setTimeout(() => {
          btDom.disabled = false;
        }, binding.value || 1000);
      }
    };
    el.addEventListener('click', forbidClick);
  },
  unbind(el: HTMLElement): void {
    el.removeEventListener('click', forbidClick);
  },
};
